var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 50.7 50.3",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 50.7 50.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1,.st3,.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.st3,.st4{fill:#69c0cf}.st4{fill:#ec2cad}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paso1",
    transform: "translate(-233 -383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(233 383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.7,
    y: 1.3,
    width: 47.2,
    height: 47.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.7,
    y: 1.3,
    width: 47.2,
    height: 47.2,
    id: "mask-2_00000049920029440883293400000012784145833807199408_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000015339364470005345270000014915846508257600397_",
    className: "st1",
    d: "M.7 1.3h47.2v47.2H.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M24.3 48.5c4 0 7.7-1 11-2.7-.6-1.1-.9-2.3-.9-3.6 0-.8.1-1.5.3-2.2-2.9 2-6.4 3.1-10.2 3.1-10 0-18.1-8.1-18.1-18.1 0-10 8.1-18.1 18.1-18.1 10 0 18.1 8.1 18.1 18.1 0 3.6-1 6.9-2.8 9.7.7-.2 1.5-.4 2.3-.4 1.2 0 2.4.3 3.4.8C47 32 47.8 28.6 47.8 25c0-13-10.6-23.6-23.6-23.6S.7 11.9.7 24.9s10.5 23.6 23.6 23.6",
    mask: "url(#mask-2_00000049920029440883293400000012784145833807199408_)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M27.5 30.9c-.1.1-.3.2-.5.2v-4.3c1.1.4 1.7 1 1.7 2 0 .9-.4 1.6-1.2 2.1zm-4.8-9.2c-.9-.3-1.4-.9-1.4-1.8 0-.7.4-1.2 1.2-1.6l.2-.1v3.5zm4.4.6v-3.9c.5.2 1 .5 1.4.9.3.2.6.4 1 .4.3 0 .7-.2.7-.2l2.3-1.5c.3-.2.5-.5.5-.8 0-.2-.1-.5-.3-.7-1.5-1.7-3.3-2.7-5.6-3.1v-2.2c0-.6-.5-1.1-1.1-1.1h-2.1c-.6 0-1.1.5-1.1 1.1v2.1c-1.1.1-2 .4-2.9.8-2.8 1.3-4.2 3.2-4.1 5.7 0 1.2.4 2.3 1.1 3.3 1.2 1.6 3.2 2.7 5.9 3.1v4.9c-1.2-.4-2.3-1.2-3.3-2.3-.2-.3-.5-.4-.9-.4-.2 0-.6.2-.6.2l-2.1 1.2c-.4.2-.5.5-.5.8 0 .2.1.4.2.6.6.8 1.3 1.5 2.2 2.2 1.5 1.2 3.2 1.9 5.1 2.2v1.9c0 .6.5 1.1 1.1 1.1h2.1c.6 0 1.1-.5 1.1-1.1v-1.9c1.7-.2 3.1-.8 4.3-1.6 1.9-1.3 2.9-3 3-5.3 0-1.4-.4-2.6-1.2-3.6-1.4-1.5-3.4-2.4-6.2-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st3",
    d: "M21.4 20c0 .8.5 1.4 1.4 1.8v-3.5l-.2.1c-.8.3-1.2.9-1.2 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st3",
    d: "M27.1 26.8v4.3c.2-.1.3-.1.5-.2.8-.5 1.2-1.2 1.2-2.1 0-1-.6-1.6-1.7-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st4",
    d: "M31.4 34.1c-1.2.8-2.7 1.3-4.3 1.6v1.9c0 .6-.5 1.1-1.1 1.1h-2.1c-.6 0-1.1-.5-1.1-1.1v-1.9c-1.9-.3-3.6-1-5.1-2.2-.9-.7-1.7-1.4-2.2-2.2-.2-.2-.2-.4-.2-.6 0-.3.2-.6.5-.8l2.1-1.2s.4-.2.6-.2c.4 0 .7.1.9.4 1 1.1 2.2 1.9 3.3 2.3v-4.9c-2.7-.4-4.7-1.4-5.9-3.1-.7-1-1.1-2.1-1.1-3.3 0-2.5 1.3-4.4 4.1-5.7.9-.4 1.8-.7 2.9-.8v-2.1c0-.6.5-1.1 1.1-1.1h2.1c.6 0 1.1.5 1.1 1.1v2.2c2.3.4 4.2 1.4 5.6 3.1.2.2.3.4.3.7 0 .3-.2.6-.5.8l-2.3 1.5s-.4.2-.7.2c-.4 0-.7-.1-1-.4-.5-.4-.9-.7-1.4-.9v3.9c2.8.4 4.8 1.4 6.1 2.9.8 1 1.2 2.2 1.2 3.6 0 2.1-1 3.9-2.9 5.2m8.4.5c1.8-2.8 2.8-6.1 2.8-9.7 0-10-8.1-18.1-18.1-18.1-10 0-18.1 8.1-18.1 18.1 0 10 8.1 18.1 18.1 18.1 3.8 0 7.3-1.1 10.2-3.1.7-2.5 2.6-4.5 5.1-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st1",
    d: "M46.3 43.3h-2.9v2.9h-2.5v-2.9H38v-2.5h2.9v-2.9h2.5v2.9h2.9v2.5zM48 42c0-3.2-2.7-5.8-5.9-5.8s-5.8 2.7-5.8 5.9 2.7 5.8 5.9 5.8S48 45.2 48 42z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(33.712 32.954)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000112619373291515562390000011265043352257030332_",
    filterUnits: "userSpaceOnUse",
    x: 0.7,
    y: 1.3,
    width: 15.6,
    height: 15.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.7,
    y: 1.3,
    width: 15.6,
    height: 15.6,
    id: "mask-4_00000065785677328045260510000008073626442275417525_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_00000112619373291515562390000011265043352257030332_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_00000063608507432746346110000008959386296814420407_",
    className: "st1",
    d: "M.7 1.3h15.6v15.6H.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M2.7 9.1c0-3.2 2.6-5.8 5.8-5.9 3.2 0 5.8 2.6 5.9 5.8 0 3.2-2.6 5.8-5.8 5.9-3.3 0-5.9-2.5-5.9-5.8m3.4-7.5C3.6 2.4 1.7 4.4 1 7 .8 7.7.6 8.4.7 9.2c0 1.3.3 2.5.9 3.6 1.3 2.5 3.9 4.2 7 4.1 4.3 0 7.8-3.6 7.8-7.9 0-3.1-1.8-5.7-4.4-7-1-.5-2.2-.8-3.4-.8-1 .1-1.8.2-2.5.4",
    mask: "url(#mask-4_00000065785677328045260510000008073626442275417525_)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st4",
    d: "M43.4 37.9h-2.5v2.9h-2.8v2.5h2.8v2.9h2.5v-2.9h2.9v-2.5h-2.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoan);
export default __webpack_public_path__ + "static/media/icon-loan.f0045957fda47861818856e4607393dc.svg";
export { ForwardRef as ReactComponent };